


































import { Component, Vue, Prop, Model, Watch } from 'vue-property-decorator';
import debounce from 'lodash/debounce';
import AdresseGouvResult from '@/models/AdresseGouvResult';
import AdresseGouvFeature from '@/models/AdresseGouvFeature';

@Component({})
export default class Autocomplete extends Vue {
    @Model('update:value') readonly value!: string;
    @Prop() search!: (value: string) => Promise<AdresseGouvFeature[]>;
    @Prop() formatSuggest!: (item: any) => string;
    @Prop() name!: string;
    @Prop() label!: string;
    @Prop() noDataLabel!: string;
    @Prop({ default: () => [] }) errors!: string[];
    @Prop({ default: false }) disabled!: boolean;
    @Prop({ default: false }) error!: boolean;

    pValue: string | undefined | null = null;
    visible: boolean = false;
    activeItem: number | null = null;
    result: any[] = [];

    created() {
        this.pValue = this.value;
    }

    @Watch('value')
    onValue() {
        this.pValue = this.value;
    }

    @Watch('pValue')
    onPValue() {
        this.$emit('update:value', this.pValue);
    }

    debouncedOnChange = debounce(this.onChange, 300);
    async onChange() {
        if (!this.pValue) {
            this.result = [];
            this.visible = false;
            return;
        }

        this.result = await this.search(this.pValue);
        this.activeItem = null;
        this.visible = true;
    }

    async onClick(item: AdresseGouvFeature | null) {
        this.visible = false;
        this.activeItem = null;
        setTimeout(() => {
            this.result = [];
        }, 500);

        if (!item) {
            return;
        }

        this.$emit('item', item);
    }

    onKeydown(event: KeyboardEvent) {
        switch (event.code) {
            case 'ArrowDown':
                event.preventDefault();
                if (this.activeItem === null) {
                    this.activeItem = 0;
                } else {
                    this.activeItem++;
                }
                if (this.activeItem >= this.result.length) {
                    this.activeItem = 0;
                }
                break;
            case 'ArrowUp':
                event.preventDefault();
                if (this.activeItem === null) {
                    this.activeItem = this.result.length - 1;
                } else {
                    this.activeItem--;
                }
                if (this.activeItem < 0) {
                    this.activeItem = this.result.length - 1;
                }
                break;
            case 'Enter':
                if (this.activeItem !== null) {
                    const item = this.result[this.activeItem];
                    this.onClick(item);
                } else {
                    this.submit();
                }
                break;
        }
    }

    submit() {
        this.$emit('submit');
    }

    onBlur() {
        setTimeout(() => {
            this.visible = false;
        }, 100);
    }

    onMouseover(item: AdresseGouvFeature) {
        const index = this.result.indexOf(item);
        if (index !== this.activeItem) {
            this.activeItem = null;
        }
    }
}
